import { useGlobalState } from '../App/globalState';
import Translations from '../Translations';

const useTranslate = () => {
  const { globalState } = useGlobalState();
  const { language } = globalState;

  return (key, options = {}) => {
    const { isError = false } = options;

    if (isError) {
      return Translations[language]?.errors?.[key] || key;
    }

    return Translations[language]?.[key] || key;
  };
};

export default useTranslate;
